import type { ComponentExposed } from "vue-component-type-helpers";
import { R3VisualComponentBase } from "./R3VisualComponenteBase.classes";
import type { R3DataFinderParams } from "~/types/components/R3/datafinder.types";
import type { R3InputTextClass } from "./R3InputBase.classes";
import type { R3Dropdown } from "#components";
import type { R3HTTPResponse } from "@r3shared/types/http";

// export type R3DataFinderFilter = {
// 	field: string;
// 	value: string | number
// }
export class R3DataFinderClass extends R3VisualComponentBase {
	constructor() {
		super();
		this.visible = false;
	}
	dropdown = autoRef<ComponentExposed<typeof R3Dropdown>>(null);
	text = autoRef<R3InputTextClass>(null);
	selectedRow = ref<unknown>(null);

	/**
	 * Nome do campo-chave da entidade pesquisada no DataFinder.
	 * Populado por `R3DataFinder.vue` na inicialização com o valor da prop `keyField`.
	 * Permite que `R3Input` / `R3InputNumber` acessem o campo-chave sem precisar
	 * receber essa informação adicionalmente.
	 */
	keyField: string = '';

	/**
	 * Valor do campo-chave da ÚLTIMA seleção confirmada pelo usuário no modal.
	 *
	 * - Definido em `R3DataFinder.vue → onConfirmButtonClick` com `row[keyField]`.
	 * - Zerado em `onDialogShow` para garantir que re-selecionar a mesma linha
	 *   continue disparando o watcher reativo nos inputs conectados.
	 * - Observado por `R3Input` e `R3InputNumber` com `{ flush: 'sync' }` para
	 *   atualizar automaticamente o valor exibido no campo.
	 */
	confirmedKeyValue = ref<string | number | null>(null);


	/**
	 * Filtra o resultado do datafinder com base no campo e valor informados
	 */
	// filter = ref<R3DataFinderFilter[]>([]);



	/**
	 * Fecha o datafinder
	 */
	close() {
		this.visible = false;
	}

	async search(params?: {
		searchField?: string,
		searchValue?: string | number,
		params?: object[],
		sync?: boolean,
		ignoreFilter?: boolean
	}) {


	}

	/**
	 * Realiza uma busca externa no data finder
	 * 
	 * @param params.searchField - Campo de busca
	 * @param params.searchValue - Valor de busca
	 * @param params.params - Parâmetros adicionais para a busca
	 * 
	 * 
	 * pode-se pesquisar externamente enviando os parâmetros
	 * ``` typescript
	 * await datafinder.externalDataFinderSearch({param1: 'param', param2: 123})
	 * ```
	 * 
	 * ou obter todos os valores da pesquisa do datafinder
	 * ``` typescript
	 * await datafinder.externalDataFinderSearch(undefined, true)
	 * ```
	 * 
	 * envie sempre o parâmetro searchAll como true para obter todos os resultados
	 */
	// Método apenas com assinatura, sem implementação (método abstrato na prática)
	async externalDataFinderSearch<Response, Params = unknown>(params: {
		searchField?: string,
		searchValue?: string | number,
		params?: R3DataFinderParams<Params>,
		SQLOverride?: string,
		ignoreFilter?: boolean
	} | undefined = undefined, searchAll: boolean = false): Promise<Response> {
		throw new Error("Not implemented. This method should be implemented in a subclass.");
	}


	show() {
		this.visible = true;
	}
}